// src/components/hub/work/UndoToast.js
import React from "react";

const UndoToast = ({ count, onRestore }) => {
  if (!count) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-white dark:bg-gray-900 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg px-4 py-3 flex items-center gap-3">
      <p className="text-sm">{count} item(s) deleted</p>
      <button
        type="button"
        onClick={onRestore}
        className="text-sm font-medium text-[#32B1FF] hover:underline"
      >
        Undo
      </button>
    </div>
  );
};

export default UndoToast;
